import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Card from '../../../components/Card';

export default function SelectableIconCard(props) {
  const {
    name,
    description,
    icon,
    onClick,
    selected = false,
    className
  } = props;

  return (
    <Card
      border={false}
      rounded={false}
      background={false}
      className={classNames(
        'flex p-4 space-x-4',
        'rounded-cs-10',
        '-m-px border',
        onClick && 'cursor-pointer hover:bg-cs-orange-50',
        selected ? 'bg-cs-yellow-50 border-cs-yellow-500' : 'border-cs-gray-100 bg-white',
        className
      )}
      onClick={onClick}
    >
      <div>
        {icon && (
          <props.icon className="w-8 h-8 text-cs-yellow-500" />
        )}
      </div>
      <div className="flex-1">
        <h2 className="text-base font-semibold text-cs-gray-900">
          {name}
        </h2>
        <div className="text-sm text-cs-gray-500">
          {description}
        </div>
      </div>
    </Card>
  );
}
